import { CustomOptionProps } from './index'

export const wapoOptions: CustomOptionProps = {
  headerIsShown: false,
  hiddenLinks: [],
  links: [],
  buttons: {},
  customText: {
    askQuestion: {
      buttonPrefix: " ",
      buttonText: "Ask The Washington Post",
      buttonSuffix: "Ask The Post a question. Receive a video answer from a journalist."
    },
    questionListHeader: "Your Questions",
    answerListHeader: "Our Answers",
    videoThumbnailHeader: "Trending"
  },
  questionsList: {
    showCategoryName: true
  },
  videoThumbnails: {
    preferenceForNames: true
  },
  helpfulHintsEnabled: false
}
